// extracted by css-extract-rspack-plugin
export default {"list":"ZH2Ng","tabLabel":"oabm_","tab":"U4uPU","tabSection":"ZSoxq"};